module.exports = __webpack_public_path__ + "static/media/logo-main.f0bf1b2a.png";